import React from 'react';
import LoadingSkeleton from '../Shared/LoadingSkeleton'; // Import Skeleton

// Added isLoading and error props
const RecentTestedServers = ({ servers = [], isLoading, error, onServerSelect }) => {
    console.log("Update: ", servers);
    return (
        <div className="bg-dark-600 rounded-2xl p-6 hover:shadow-lg transition-medium transform-gpu hover:scale-[1.01] border border-dark-400 hover:border-dark-300 min-h-[250px] flex flex-col">
            <div className="flex items-center mb-5 flex-shrink-0">
                <h3 className="font-bold text-lg flex items-center">
                    <i className="fas fa-history mr-2 text-accent-purple opacity-80"></i>
                    Recent Tested Servers
                    {isLoading && <i className="fas fa-spinner fa-spin text-xs ml-2 text-gray-400"></i>}
                </h3>
            </div>
            <div className="flex-1 space-y-3 pr-2 overflow-y-auto custom-scrollbar">
                {isLoading ? (
                    <LoadingSkeleton count={4} />
                 ) : error ? (
                    /*<p className="text-center text-accent-red text-sm py-8">{error}</p>*/
                    <p className="text-gray-400 text-center py-8">{error}</p>
                ) : servers.length === 0 ? (
                    <p className="text-gray-400 text-center py-8">No recent servers found</p>
                ) : (
                    servers.map((server, index) => (
                        <div
                            key={index}
                            onClick={() => onServerSelect && onServerSelect(server.ip)}
                            className="flex items-center justify-between p-3 bg-dark-500 rounded-xl hover:bg-dark-400 transition-medium cursor-pointer group transform-gpu hover:-translate-y-1 hover:shadow-md"
                        >
                            <div className="flex items-center overflow-hidden"> {/* Added overflow-hidden */}
                                <div className={`w-10 h-10 rounded-lg bg-gradient-to-br ${server.gradient || 'from-gray-500 to-gray-600'} flex items-center justify-center mr-3 transition-medium group-hover:rotate-6 transform-gpu flex-shrink-0`}>
                                    <i className="fas fa-server text-xs"></i>
                                </div>
                                <div className="overflow-hidden"> {/* Added overflow-hidden */}
                                    <p className="font-medium group-hover:text-white transition-medium truncate">{server.ip}</p> {/* Added truncate */}
                                    <p className="text-xs text-gray-400 group-hover:text-gray-300 transition-medium">
                                        <span className={server.status === 'Online' ? 'text-accent-green' : 'text-accent-red'}>●</span> {server.status} • {server.players} players
                                    </p>
                                </div>
                            </div>
                            <div className="flex items-center flex-shrink-0 ml-2">
                                <span className={`text-xs px-2 py-1 ${server.riskClass} rounded-lg mr-2 whitespace-nowrap`}>
                                    {server.risk}
                                </span>
                                {/* Removed button - not interactive here */}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};


export default RecentTestedServers;